cv.AlertView = Marionette.LayoutView.extend({
  id: 'modal-alert',

  template: cv.Templates['global/modals/alert'],

  events : {
    'click .modal-confirm' : 'confirm',
  },

  validation: {},

  initialize: function(options){
    this.options = options;

    console.log('AlertView initialized');
  },

  templateHelpers: function(){
    return {
      title : _.has(this.options, 'title') ? this.options.title : 'Alert',
      message : _.has(this.options, 'message') ? this.options.message : '',
      confirm : _.has(this.options, 'confirm') ? this.options.confirm : 'Close',
    };
  },

  confirm: function(e){
    e.preventDefault();

    this.trigger('confirm');
    vent.trigger('modal:hide');
  }
});
